import API from 'src/plugins/api/api'
import { DEFAULT_FILTER_KEYS, toApiFilters, toStoreFilters } from 'src/plugins/helpers/wallboard-default-filters'

export default {
  /**
   * Fetch live calls
   */
  async fetchLiveCalls ({ commit, state }) {
    try {
      if (state.isLiveCallsLoading) {
        return
      }

      commit('SET_LIVE_CALLS_LOADING', true)

      const res = await API.V1.contactCenter.liveCalls.get({
        ring_group_ids: state.filters.ringGroupIds
      })

      commit('SET_LIVE_CALLS', res.data)
      commit('SET_LIVE_CALLS_LOADING', false)
    } catch (err) {
      commit('SET_LIVE_CALLS_LOADING', false)
      console.log(err.response || err)
      this._vm.$handleErrors(err.response)
    }
  },

  /**
   * Fetch parked calls
   */
  async fetchParkedCalls ({ commit, state }) {
    try {
      if (state.isParkedCallsLoading) {
        return
      }

      commit('SET_PARKED_CALLS_LOADING', true)

      const res = await API.V1.contactCenter.parkedCalls.get({
        ring_group_ids: state.filters.ringGroupIds
      })

      commit('SET_PARKED_CALLS', res.data)
      commit('SET_PARKED_CALLS_LOADING', false)
    } catch (err) {
      commit('SET_PARKED_CALLS_LOADING', false)
      console.log(err.response || err)
      this._vm.$handleErrors(err.response)
    }
  },

  /**
   * Fetch live calls
   */
  async fetchQueuedCalls ({ commit, state }) {
    try {
      if (state.isQueuedCallsLoading) {
        return
      }

      commit('SET_QUEUED_CALLS_LOADING', true)

      const res = await API.V1.contactCenter.queuedCalls.get({
        ring_group_ids: state.filters.ringGroupIds
      })

      commit('SET_QUEUED_CALLS', res.data)
      commit('SET_QUEUED_CALLS_LOADING', false)
    } catch (err) {
      commit('SET_QUEUED_CALLS_LOADING', false)
      console.log(err.response || err)
      this._vm.$handleErrors(err.response)
    }
  },

  /**
   * Fetch summary data for contact center
   */
  async fetchSummary ({ commit, state }) {
    try {
      if (state.isSummaryLoading) {
        return
      }

      commit('SET_SUMMARY_LOADING', true)

      const res = await API.V1.contactCenter.summary.get({
        ring_group_ids: state.filters.ringGroupIds,
        campaign_ids: state.filters.campaignIds,
        team_ids: state.filters.teamIds,
        timezone: window.timezone
      })
      const summary = res.data

      commit('SET_SUMMARY', {
        abandonedCalls: summary.abandoned_calls,
        answeredCalls: summary.answered_calls,
        appointmentsSet: summary.appointments,
        averageTalkTime: summary.average_talk_time,
        averageWaitTime: summary.average_wait_time,
        emailsReceived: summary.emails_received,
        emailsSent: summary.emails_sent,
        faxesReceived: summary.faxes_received,
        faxesSent: summary.faxes_sent,
        missedCalls: summary.missed_calls,
        remindersSet: summary.reminders,
        textsReceived: summary.sms_received,
        textsSent: summary.sms_sent,
        totalCalls: summary.total_calls,
        totalOccupancy: summary.total_occupancy
      })

      commit('SET_SUMMARY_LOADING', false)
    } catch (err) {
      commit('SET_SUMMARY_LOADING', false)
      console.log(err.response || err)
      this._vm.$handleErrors(err.response)
    }
  },

  /**
   * Replace the Line, Inbox and Team filters with the user's saved defaults, if any
   */
  applyDefaultFilters ({ commit, getters, rootState }) {
    const defaults = getters.getDefaultFilters

    if (!defaults) {
      return
    }

    const filters = toStoreFilters(defaults, rootState)

    for (const [filter, value] of Object.entries(filters)) {
      commit('SET_FILTER', { filter, value })
    }
  },

  /**
   * Save the current Line, Inbox and Team filters as the user's defaults
   */
  async saveDefaultFilters ({ commit, state }) {
    const res = await API.V1.user.wallboardDefaultFilters.save(toApiFilters(state.filters))

    commit('auth/SET_PROFILE', { setting_wallboard_default_filters: res.data.data }, { root: true })
  },

  /**
   * Remove the user's default filters and reset the Line, Inbox and Team filters to everyone
   */
  async clearDefaultFilters ({ commit, dispatch }) {
    await API.V1.user.wallboardDefaultFilters.clear()

    commit('auth/SET_PROFILE', { setting_wallboard_default_filters: null }, { root: true })

    for (const filter of Object.keys(DEFAULT_FILTER_KEYS)) {
      commit('SET_FILTER', { filter, value: [] })
    }

    dispatch('fetchSummary')
  },

  /**
   * Set agent status, calling the API and updating the store
   */
  async setAgentStatus ({ commit }, params) {
    try {
      const response = await API.V1.users.setAgentStatus(params.userId, params.status)

      commit('UPDATE_USER_STATUS', response.data, { root: true })
    } catch (err) {
      console.log(err.response || err)
      this._vm.$handleErrors(err.response)
    }
  }
}
